import { runStrapiCommand } from './commands';

runStrapiCommand(process.argv);
